import { TicketState } from '@treadinc/horizon-api-spec';

import { TicketFilterParams } from '~hooks/useTickets/useTickets';

import { TabFilter } from './types';

export const TAB_SERVER_FILTERS = {
  [TabFilter.MISSING]: { missing_image: true },
  [TabFilter.PENDING]: { missing_load: true },
  [TabFilter.NEW]: { states: [TicketState.NEW] },
  [TabFilter.APPROVED]: { states: [TicketState.APPROVED] },
  [TabFilter.VOIDED]: { states: [TicketState.VOIDED] },
  [TabFilter.All]: {},
} satisfies Record<TabFilter, TicketFilterParams>;
